import { hasEnabledSvgMapEditor } from "@gettactic/helpers/src/featureFlags";
import { useAuthenticated } from "@gettactic/hooks";
import { useSyncExternalStore } from "react";

const subscribe = (onChange: () => void) => {
  window.addEventListener("storage", onChange);
  return () => window.removeEventListener("storage", onChange);
};

/**
 * Whether this person gets the SVG map editor and viewer
 * (`localStorage.mapBuilder = "2"`), read in a way the server and the
 * first client render agree on: the server answer is always "no", so a
 * server-rendered map page hydrates cleanly and switches right after.
 */
export const useSvgMapEditorEnabled = (): boolean => {
  const {
    userContext: { authenticatedUser }
  } = useAuthenticated();
  return useSyncExternalStore(
    subscribe,
    () => hasEnabledSvgMapEditor(authenticatedUser),
    () => false
  );
};
